(function () {
  'use strict';
  if (window.CsgMy27) { window.CsgMy27.initAll(); return; }
  const instances = new Map();
  const plan = { schedule: ["hardtail", "e_fully", "gravel", "e_hardtail", "e_trekking", "road", "kids", "youth", "fully", "trekking", "e_gravel", "e_city", "cargo"] };
  const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  function slotInfo(time) {
    const p = Object.fromEntries(fmt.formatToParts(new Date(time)).map(part => [part.type, part.value]));
    const date = p.year + '-' + p.month + '-' + p.day;
    const slot = Number(p.hour) * 2 + Math.floor(Number(p.minute) / 30);
    return { date, slot, key: date + ':' + slot, day: Math.floor(Date.parse(date + 'T00:00:00Z') / 86400000) };
  }
  function nextBoundary(time) {
    // Berlin's contemporary UTC offsets are whole hours, including DST.
    return (Math.floor(time / 1800000) + 1) * 1800000;
  }

  const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  function compactSize(label) {
    return String(label || '').replace(/easy[ -]?entry|trapeze?/gi, '').replace(/\s+/g, ' ').trim();
  }
  function sizeGroup(product, variant) {
    const label = compactSize(variant.size).toUpperCase();
    if (/ONE\s*SIZE|EINHEITS|UNISIZE/.test(label)) return '';
    if (product.family === 'kids') {
      const wheel = label.match(/^(12|14|16|18|20|24|26|27[.,]5|29)\s*(?:["″]|ZOLL|INCH)$/);
      return wheel ? wheel[1].replace(',', '.') : '';
    }
    if (label === 'XXS') return 'XS';
    if (sizeOrder.includes(label)) return label;
    const cm = label.match(/^(\d{2})(?:[.,]0)?\s*(?:CM)?$/);
    if (!cm) return '';
    const title = product.title.toLowerCase();
    const road = {47:'XS',50:'XS',52:'S',53:'S',54:'M',56:'M',58:'L',60:'XL',62:'XXL'};
    const trekking = {46:'XS',50:'S',54:'M',58:'L',62:'XL',64:'XXL'};
    const city = {42:'XS',46:'S',50:'M',54:'L',58:'XL'};
    const aruba = {45:'S',49:'M',53:'L'};
    const mapping = /agree|attain|litening/.test(title) ? road : /supreme|aruba.*hybrid/.test(title) ? city : /aruba/.test(title) ? aruba : /kathmandu|touring|nuride|nature|editor/.test(title) ? trekking : {};
    return mapping[Number(cm[1])] || '';
  }
  function eligibleVariants(product, size = '') {
    return (product.variants || []).filter(v => (v.inStock === true || v.preorder === true) && (!size || sizeGroup(product, v) === size));
  }
  function forSize(product, size = '') {
    const candidates = eligibleVariants(product, size).slice().sort((a,b) => Number(b.inStock) - Number(a.inStock) || (a.inStock ? 0 : (a.preorderISO || '9999').localeCompare(b.preorderISO || '9999')) || a.priceCents - b.priceCents || a.id.localeCompare(b.id));
    const v = candidates[0];
    if (!v) return null;
    const stockSizes = [...new Set(candidates.filter(c => c.inStock).map(c => {
      const sameConfiguration = (c.options || []).every((value, i) => i === product.sizeIndex || value === (v.options || [])[i]);
      return sameConfiguration ? compactSize(c.size) : c.variant;
    }).filter(Boolean))].join(' · ');
    const url = new URL(product.url, location.origin); url.searchParams.set('variant', v.id);
    return { ...product, ...v, id: product.id, variantId: v.id, url: url.pathname + url.search + url.hash, stockSizes, selectedSize: size };
  }
  function selectSlot(items, key, count, preferredFamily = '', size = '') {
    const [date, slotText] = key.split(':');
    const slot = Number(slotText), day = Math.floor(Date.parse(date + 'T00:00:00Z') / 86400000);
    if (!Number.isFinite(day) || !Number.isInteger(slot) || slot < 0 || slot > 47) return { items: [], family: '' };
    const unique = new Map(items.filter(p => p.id && p.title && p.url && p.image && p.modelYear === 2027 && p.available === true && plan.schedule.includes(p.family)).map(p => [String(p.id), p]));
    const categoryIndex = slot % plan.schedule.length;
    const order = plan.schedule.slice(categoryIndex).concat(plan.schedule.slice(0, categoryIndex));
    const family = plan.schedule.includes(preferredFamily) ? preferredFamily : order.find(f => [...unique.values()].some(p => p.family === f && eligibleVariants(p, size).length));
    if (!family) return { items: [], family: '' };
    const group = [...unique.values()].filter(p => p.family === family).map(p => forSize(p, size)).filter(Boolean);
    const capacity = Math.max(1, Math.min(120, Math.floor(Number(count) || 120)));
    function rotate(pool, slots) {
      const target = Math.min(pool.length, slots);
      if (!target) return [];
      const stride = Math.max(1, Math.min(target, pool.length - 1));
      const offset = ((day * stride + slot) % pool.length + pool.length) % pool.length;
      return Array.from({ length: target }, (_, i) => pool[(offset + i) % pool.length]);
    }
    const stocked = rotate(group.filter(p => p.inStock), capacity);
    const preorders = rotate(group.filter(p => !p.inStock && p.preorder), capacity - stocked.length);
    return { family, items: stocked.concat(preorders), total: group.length };
  }
  function create(tag, cls, text) {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }
  // Decode translated HTML entities once before assigning plain text. Never
  // interpret editor text as HTML: this also fixes visible "City &amp; Trekking".
  function plainText(value) {
    const named = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: '\u00a0' };
    return value.replace(/&(#x[0-9a-f]+|#\d+|amp|lt|gt|quot|apos|nbsp);/gi, (entity, code) => {
      if (code[0] !== '#') return named[code.toLowerCase()];
      const number = code[1].toLowerCase() === 'x' ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10);
      return number > 0 && number <= 0x10ffff ? String.fromCodePoint(number) : entity;
    });
  }
  function imageUrl(source, width) {
    const url = new URL(source, location.href);
    url.searchParams.set('width', width);
    return url.href;
  }
  function card(p, strings) {
    const li = create('li', 'csg27-card');
    li.dataset.productId = p.id; li.dataset.family = p.family;
    const a = create('a', 'csg27-card-link'); a.href = p.url;
    const visual = create('div', 'csg27-image');
    visual.append(create('span', 'csg27-badge', ['kids','youth'].includes(p.family) ? strings.kids_badge : 'MY27'));
    const img = create('img'); img.src = imageUrl(p.image, 480); img.alt = p.title;
    img.srcset = [320, 480, 640, 960].map(width => imageUrl(p.image, width) + ' ' + width + 'w').join(', ');
    img.sizes = '(max-width: 540px) 86vw, (max-width: 800px) 50vw, (max-width: 1100px) 33vw, (max-width: 1420px) 25vw, 330px';
    img.width = 640; img.height = 480; img.loading = 'lazy'; img.decoding = 'async';
    visual.append(img);
    const body = create('div', 'csg27-body');
    body.append(create('span', 'csg27-type', strings.families[p.family]));
    body.append(create('h3', 'csg27-title', p.title.replace(/^cube\s+/i, '').replace(/\s+2027$/i, '')));
    body.append(create('p', 'csg27-variant', p.variant && p.variant !== 'Default Title' ? (strings.price_for || '%variant%').replace('%variant%', p.variant) : strings.variant));
    if (p.inStock === true) body.append(create('span', 'csg27-stock', strings.in_stock + (p.stockSizes ? ': ' + p.stockSizes : '')));
    else if (p.preorder === true) body.append(create('span', 'csg27-stock csg27-preorder', p.preorderDate ? strings.preorder_from.replace('%date%', p.preorderDate) : strings.preorder));
    const price = create('div', 'csg27-price'); price.append(create('strong', '', p.price));
    body.append(price);
    const link = create('span', 'csg27-card-cta', strings.discover);
    const arr = create('span', '', '→'); arr.setAttribute('aria-hidden', 'true'); link.append(arr);
    body.append(link); a.append(visual, body); li.append(a); return li;
  }
  class Carousel {
    constructor(root) {
      this.root = root; this.track = root.querySelector('[data-csg27-track]');
      this.initialIds = Array.from(this.track.children, card => card.dataset.productId).filter(Boolean);
      this.prev = root.querySelector('[data-csg27-prev]'); this.next = root.querySelector('[data-csg27-next]');
      this.position = root.querySelector('[data-csg27-position]'); this.live = root.querySelector('[data-csg27-live]');
      this.strings = JSON.parse(root.querySelector('[data-csg27-strings]').textContent, (_, value) => typeof value === 'string' ? plainText(value) : value);
      this.key = ''; this.lastFetch = 0; this.items = []; this.limit = Math.max(4, Math.min(120, Number(root.dataset.limit) || 24));
      this.sources = JSON.parse(root.querySelector('[data-csg27-sources]')?.textContent || '{}');
      this.loadedFamily = ''; this.requestVersion = 0; this.lastAttempt = 0; this.pendingCatalogue = null;
      this.root.dataset.family = root.dataset.renderedFamily || '';
      this.picker = root.querySelector('[data-csg27-picker]');
      this.pickerSelect = root.querySelector('[data-csg27-select]');
      this.manualFamily = plan.schedule.includes(root.dataset.defaultFamily) ? root.dataset.defaultFamily : '';
      this.sizes = { adult: '', kids: '' };
      this.sizeSelect = root.querySelector('[data-csg27-size]');
      this.empty = root.querySelector('[data-csg27-empty]');
      this.emptyDefault = this.empty.innerHTML;
      this.reset = root.querySelector('[data-csg27-reset]');
      this.preferenceKey = 'csg27-family:' + root.dataset.feed;
      try {
        const saved = sessionStorage.getItem(this.preferenceKey);
        if (saved === '' || plan.schedule.includes(saved)) this.manualFamily = saved;
        const sizes = JSON.parse(sessionStorage.getItem(this.preferenceKey + ':sizes') || '{}');
        if (sizeOrder.includes(sizes.adult)) this.sizes.adult = sizes.adult;
        if (/^(12|14|16|18|20|24|26|27\.5|29)$/.test(sizes.kids)) this.sizes.kids = sizes.kids;
      } catch {}
      this.loading = false; this.destroyed = false;
      this.visible = false; this.near = false; this.deferredRender = false;
      this.pageLoaded = document.readyState === 'complete'; this.selectedItems = null;
      this.events = new AbortController(); const opt = { signal: this.events.signal };
      this.prev.addEventListener('click', () => this.scroll(-1), opt);
      this.next.addEventListener('click', () => this.scroll(1), opt);
      if (this.picker) this.picker.addEventListener('click', e => {
        const button = e.target.closest('[data-csg27-family]');
        if (button && this.picker.contains(button)) this.chooseFamily(button.dataset.csg27Family);
      }, opt);
      if (this.pickerSelect) this.pickerSelect.addEventListener('change', e => this.chooseFamily(e.target.value), opt);
      this.sizeSelect.addEventListener('change', e => this.chooseSize(e.target.value), opt);
      this.reset.addEventListener('click', () => this.chooseSize(''), opt);
      this.track.addEventListener('scroll', () => {
        if (this.track.scrollLeft > 2) this.initialScrollIntent = true;
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.enhanceAfterScroll(); this.appendNearEnd(); this.controls(); });
      }, { passive: true, signal: this.events.signal });
      this.track.addEventListener('pointerdown', () => { clearTimeout(this.pointerReleaseTimer); this.pointerActive = true; }, { passive: true, signal: this.events.signal });
      const releasePointer = () => {
        if (!this.pointerActive) return;
        this.pointerReleaseTimer = setTimeout(() => { this.pointerActive = false; this.enhanceAfterScroll(); this.flushDeferred(); }, 0);
      };
      window.addEventListener('pointerup', releasePointer, opt);
      window.addEventListener('pointercancel', releasePointer, opt);
      // Native touch panning cancels Pointer Events before the finger lifts.
      // Keep that contact protected until its own touchend/touchcancel event.
      this.track.addEventListener('touchstart', () => { clearTimeout(this.touchReleaseTimer); this.touchActive = true; }, { passive: true, signal: this.events.signal });
      const releaseTouch = event => {
        if (!this.touchActive || event.touches?.length) return;
        this.touchReleaseTimer = setTimeout(() => { this.touchActive = false; this.enhanceAfterScroll(); this.flushDeferred(); }, 0);
      };
      window.addEventListener('touchend', releaseTouch, { passive: true, signal: this.events.signal });
      window.addEventListener('touchcancel', releaseTouch, { passive: true, signal: this.events.signal });
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.scroll(e.key === 'ArrowRight' ? 1 : -1); }
        if (e.key === 'Home') { e.preventDefault(); this.track.scrollTo({ left: 0 }); }
      }, opt);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.checkSlot(); }, opt);
      window.addEventListener('pageshow', () => this.checkSlot(), opt);
      this.resize = new ResizeObserver(() => this.controls()); this.resize.observe(this.track);
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.flushDeferred();
          this.checkSlot();
        });
        this.visibility.observe(this.root);
        this.proximity = new IntersectionObserver(entries => {
          this.near = entries.some(entry => entry.isIntersecting);
          if (this.near && this.pageLoaded) this.checkSlot();
          if (!this.near) clearTimeout(this.timer);
        }, { rootMargin: '200px 0px' });
        this.proximity.observe(this.root);
      } else {
        this.visible = this.near = true;
      }
      window.addEventListener('load', () => { this.pageLoaded = true; this.checkSlot(); }, { once: true, signal: this.events.signal });
      const activate = () => { this.near = this.pageLoaded = true; this.checkSlot(); };
      this.root.addEventListener('focusin', activate, opt);
      this.root.addEventListener('pointerdown', activate, opt);
      this.root.addEventListener('focusout', () => queueMicrotask(() => this.flushDeferred()), opt);
      this.root.dataset.catalogueStatus = 'idle';
      if (this.pickerSelect) { this.pickerSelect.disabled = false; this.pickerSelect.value = this.manualFamily; }
      if (!this.track.children.length) this.empty.hidden = false;
      this.controls(); this.checkSlot();
    }
    currentSize() {
      const family = this.manualFamily || this.root.dataset.family;
      if (!this.items.some(p => p.family === family && eligibleVariants(p).some(v => sizeGroup(p, v)))) return '';
      return this.sizes[family === 'kids' ? 'kids' : 'adult'];
    }
    savePreferences() {
      try {
        sessionStorage.setItem(this.preferenceKey, this.manualFamily);
        sessionStorage.setItem(this.preferenceKey + ':sizes', JSON.stringify(this.sizes));
      } catch {}
    }
    chooseFamily(family) {
      if (family !== '' && !plan.schedule.includes(family)) return;
      if (family === this.manualFamily && this.root.dataset.catalogueStatus === 'ready' && !this.pendingCatalogue) return;
      this.manualFamily = family;
      if (!family) this.sizes = { adult: '', kids: '' };
      this.savePreferences();
      this.deferredRender = false;
      this.pendingCatalogue = null;
      this.near = this.pageLoaded = true;
      this.load(true);
    }
    chooseSize(size) {
      if (!this.key) return;
      if (this.pendingCatalogue && this.pendingCatalogue.result.family === this.loadedFamily) {
        const pending = this.pendingCatalogue; this.pendingCatalogue = null;
        this.applyCatalogue(pending.result, pending.key, true);
      }
      if (this.manualFamily && this.loadedFamily !== this.manualFamily) return;
      // Pinning the visible family supersedes an automatic request in flight.
      // Its shared network request may still populate the cache for another view.
      this.requestVersion++; this.loading = false; this.pendingCatalogue = null;
      this.root.removeAttribute('aria-busy'); this.root.dataset.catalogueStatus = 'ready';
      if (!this.manualFamily) this.manualFamily = this.root.dataset.family;
      const mode = this.manualFamily === 'kids' ? 'kids' : 'adult';
      this.sizes[mode] = size;
      this.savePreferences();
      this.deferredRender = false;
      this.render(true, true);
    }
    syncPicker() {
      if (!this.picker) return;
      this.picker.hidden = false;
      this.root.dataset.selectionMode = this.manualFamily ? 'manual' : 'auto';
      this.pickerSelect.disabled = false; this.pickerSelect.value = this.manualFamily;
      const family = this.manualFamily || this.root.dataset.family;
      const kids = family === 'kids', current = this.currentSize();
      const counts = new Map();
      for (const product of this.items.filter(p => p.family === family)) {
        for (const group of new Set(eligibleVariants(product).map(v => sizeGroup(product, v)).filter(Boolean))) counts.set(group, (counts.get(group) || 0) + 1);
      }
      const values = kids ? [...new Set([...counts.keys(), ...(current ? [current] : [])])].sort((a,b) => Number(a)-Number(b)) : sizeOrder;
      const fragment = document.createDocumentFragment();
      const all = create('option', '', this.strings.all_sizes); all.value = ''; fragment.append(all);
      for (const value of values) {
        const label = kids ? value.replace('.', ',') + '″' : value;
        const option = create('option', '', label + ' (' + (counts.get(value) || 0) + ')'); option.value = value; option.disabled = !counts.get(value); fragment.append(option);
      }
      this.sizeSelect.replaceChildren(fragment); this.sizeSelect.value = current;
      this.sizeSelect.disabled = counts.size === 0 && !current;
      this.root.querySelector('[data-csg27-size-label]').textContent = kids ? this.strings.wheel_label : this.strings.size_label;
      const hint = this.root.querySelector('[data-csg27-size-hint]');
      hint.textContent = counts.size ? this.strings.size_hint : this.strings.no_options;
      hint.hidden = kids;
      this.reset.hidden = !current;
    }
    appendCards() {
      if (!this.selectedItems) return;
      const start = this.track.children.length;
      const fragment = document.createDocumentFragment();
      this.selectedItems.slice(start, start + 12).forEach(product => fragment.append(card(product, this.strings)));
      this.track.append(fragment);
    }
    appendNearEnd() {
      if (this.selectedItems && this.track.scrollWidth - this.track.clientWidth - this.track.scrollLeft < this.track.clientWidth) this.appendCards();
    }
    restoringPreference(result) {
      return !this.signature && this.manualFamily && result.family === this.manualFamily &&
        (result.family !== this.root.dataset.family || this.sizes[result.family === 'kids' ? 'kids' : 'adult']);
    }
    productInteraction() {
      return this.pointerActive || this.touchActive || (this.track.contains(document.activeElement) && document.activeElement !== this.track);
    }
    enhanceAfterScroll() {
      if (this.destroyed || this.signature || !this.initialScrollIntent || !this.pendingCatalogue || this.productInteraction()) return;
      const pending = this.pendingCatalogue;
      if (pending.result.family !== this.root.dataset.family || this.track.scrollWidth - this.track.clientWidth - this.track.scrollLeft > this.track.clientWidth) return;
      const position = this.track.scrollLeft;
      this.initialScrollIntent = false; this.pendingCatalogue = null;
      this.applyCatalogue(pending.result, pending.key, true);
      this.track.scrollLeft = position;
      this.controls();
    }
    scroll(dir) {
      if (this.pendingCatalogue && this.pendingCatalogue.result.family === this.loadedFamily) {
        const pending = this.pendingCatalogue; this.pendingCatalogue = null;
        this.applyCatalogue(pending.result, pending.key, true);
      }
      if (dir > 0) this.appendNearEnd();
      const first = this.track.firstElementChild; if (!first) return;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 18);
      const per = Math.max(1, Math.floor((this.track.clientWidth + 18) / step));
      this.track.scrollBy({ left: dir * step * per, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    controls() {
      const n = this.selectedItems ? this.selectedItems.length : this.pendingCatalogue && !this.signature && this.pendingCount ? this.pendingCount : this.track.children.length;
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = !n || this.track.scrollLeft < 3;
      this.next.disabled = !n || max < 3 || this.track.scrollLeft >= max - 3;
      if (this.pendingCatalogue && !this.signature && this.pendingCount > this.track.children.length) this.next.disabled = false;
      if (!n) { this.position.textContent = ''; return; }
      const first = this.track.firstElementChild;
      if (!first) { this.position.textContent = ''; return; }
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 18);
      const start = Math.min(n, Math.round(this.track.scrollLeft / step) + 1);
      const visible = Math.max(1, Math.floor((this.track.clientWidth + 18) / step));
      this.position.textContent = start + '–' + Math.min(n, start + visible - 1) + ' / ' + n;
    }
    flushDeferred() {
      if (this.destroyed) return;
      if (this.pendingCatalogue && this.restoringPreference(this.pendingCatalogue.result) && !this.productInteraction()) {
        const pending = this.pendingCatalogue; this.pendingCatalogue = null;
        this.applyCatalogue(pending.result, pending.key, true);
      }
      if (this.visible || this.root.contains(document.activeElement) || this.productInteraction()) return;
      if (this.pendingCatalogue) {
        const pending = this.pendingCatalogue; this.pendingCatalogue = null;
        if (pending.key === slotInfo(Date.now()).key && (!this.manualFamily || pending.result.family === this.manualFamily)) this.applyCatalogue(pending.result, pending.key, true);
      }
      if (this.deferredRender) {
        this.deferredRender = false;
        this.render(true);
      }
      this.checkSlot();
    }
    render(announce, force = false) {
      // Do not replace bikes or move focus while a visitor is viewing them.
      if (!force && this.signature && (this.visible || this.root.contains(document.activeElement))) {
        this.deferredRender = true;
        return;
      }
      const selection = selectSlot(this.items, this.key, this.limit, this.manualFamily || this.loadedFamily, this.manualFamily ? this.currentSize() : '');
      let selected = selection.items;
      if (!this.signature && selection.family === this.root.dataset.renderedFamily && !this.currentSize()) {
        // Keep the initial bikes at the start. The first Next click must not
        // encounter those same bikes again later in the enhanced list.
        const preview = new Map(selectSlot(this.items.filter(p => this.initialIds.includes(String(p.id))), this.key, 4, selection.family).items.map(p => [String(p.id), p]));
        const first = this.initialIds.map(id => preview.get(id)).filter(Boolean);
        selected = first.concat(selected.filter(p => !preview.has(String(p.id)))).slice(0, this.limit);
      }
      this.root.dataset.family = selection.family;
      this.track.dataset.count = selected.length;
      this.syncPicker();
      const familyLabel = this.strings.families[selection.family];
      if (familyLabel) this.root.querySelector('[data-csg27-title]').textContent = this.strings.heading.replace('%family%', familyLabel);
      const chosenSize = this.currentSize();
      this.root.querySelector('[data-csg27-note]').textContent = (chosenSize ? this.strings.filtered_note : this.manualFamily ? this.strings.manual_note : this.strings.note).replace('%count%', selected.length).replace('%size%', selection.family === 'kids' ? chosenSize + '″' : chosenSize);
      this.root.dataset.selectionSlot = this.key;
      if (announce && familyLabel) this.live.textContent = this.strings.updated.replace('%family%', familyLabel).replace('%count%', selected.length);
      const signature = JSON.stringify([this.manualFamily, this.currentSize(), selection.family, selected]);
      if (signature === this.signature) return;
      this.signature = signature;
      this.selectedItems = selected;
      if (!selected.length) {
        this.track.replaceChildren();
        if (this.currentSize()) this.empty.textContent = this.strings.filtered_empty; else this.empty.innerHTML = this.emptyDefault;
        this.empty.hidden = false;
        this.controls(); return;
      }
      const previousFocus = this.root.contains(document.activeElement) && this.track.contains(document.activeElement);
      this.root.querySelector('[data-csg27-empty]').hidden = true;
      this.track.replaceChildren(); this.appendCards(); this.track.scrollLeft = 0;
      this.controls();
      if (previousFocus) this.track.focus({ preventScroll: true });
    }
    familyFor(key) {
      return this.manualFamily || plan.schedule[Number(key.split(':')[1]) % plan.schedule.length];
    }
    feedUrl(family) {
      const url = new URL(this.sources[family] || this.root.dataset.feed, location.origin);
      url.searchParams.set('section_id', 'csg-my27-feed-' + family);
      return url.href;
    }
    applyCatalogue(result, key, force) {
      this.lastFetch = result.fetchedAt;
      const decode = value => typeof value === 'string' ? plainText(value) : Array.isArray(value) ? value.map(decode) : value && typeof value === 'object' ? Object.fromEntries(Object.entries(value).map(([k, v]) => [k, decode(v)])) : value;
      const restore = this.restoringPreference(result) && !this.productInteraction();
      if (!force && !restore && (this.visible || this.root.contains(document.activeElement) || this.productInteraction()) && (this.signature || this.track.children.length)) {
        this.pendingCatalogue = { result, key };
        // Keep visible server cards stable. Filters/Next can explicitly accept
        // the data immediately, without extra requests or reserved empty space.
        if (!this.signature) {
          this.items = decode(result.items); this.loadedFamily = result.family; this.key = key;
          this.pendingCount = selectSlot(this.items, key, this.limit, result.family).items.length;
          if (result.family === this.root.dataset.family) this.syncPicker();
          this.controls();
          this.enhanceAfterScroll();
        }
        return;
      }
      this.items = decode(result.items); this.loadedFamily = result.family;
      const announce = Boolean(this.key); this.key = key;
      this.render(announce, true);
    }
    async load(forceRender = false, refresh = false) {
      if (this.destroyed) return;
      const key = slotInfo(Date.now()).key, family = this.manualFamily || (refresh && this.loadedFamily) || this.familyFor(key);
      if (this.loading && this.requestedFamily === family && !forceRender) return;
      const version = ++this.requestVersion;
      this.requestedFamily = family; this.lastAttempt = Date.now();
      this.loading = true; this.root.dataset.catalogueStatus = 'loading'; this.root.setAttribute('aria-busy', 'true');
      this.sizeSelect.disabled = true;
      try {
        if (!window.CsgCatalogueCache) throw new Error('Catalogue cache unavailable');
        const start = plan.schedule.indexOf(family);
        const families = this.manualFamily ? [family] : plan.schedule.slice(start).concat(plan.schedule.slice(0, start));
        let result;
        for (const candidate of families) {
          result = await window.CsgCatalogueCache.get(this.feedUrl(candidate), {
            selector: '[data-csg27-feed]', family: candidate, mode: 'my27',
            locale: document.documentElement.lang, currency: this.root.dataset.currency
          });
          if (this.destroyed || version !== this.requestVersion) return;
          // Only Automatic advances past an empty category; a manual choice stays selected.
          if (selectSlot(result.items, key, this.limit, candidate).items.length || this.manualFamily) break;
        }
        if (this.destroyed || version !== this.requestVersion) return;
        this.applyCatalogue(result, key, forceRender);
        this.root.dataset.catalogueStatus = 'ready';
      } catch (error) {
        if (this.destroyed || version !== this.requestVersion) return;
        this.root.dataset.catalogueStatus = 'fallback';
        this.root.querySelector('[data-csg27-note]').textContent = this.strings.fallback;
        if (!this.track.children.length) this.root.querySelector('[data-csg27-empty]').hidden = false;
        console.warn('[CUBE MY27] Live feed temporarily unavailable; retaining rendered products.', error);
      } finally {
        if (!this.destroyed && version === this.requestVersion) {
          this.loading = false; this.root.removeAttribute('aria-busy');
          if (this.loadedFamily && this.loadedFamily === this.root.dataset.family && (!this.manualFamily || this.manualFamily === this.loadedFamily)) this.syncPicker();
          this.schedule();
        }
      }
    }
    checkSlot() {
      if (this.destroyed || document.hidden || !this.near || !this.pageLoaded) return;
      const key = slotInfo(Date.now()).key;
      // Keep the inspected bikes stable, including when the half-hour changes.
      if (this.key && (this.signature || this.track.children.length) && key !== this.key && (this.visible || this.root.contains(document.activeElement))) { this.schedule(); return; }
      const pending = this.pendingCatalogue?.key === key;
      const stale = !this.lastFetch || Date.now() - this.lastFetch >= (window.CsgCatalogueCache?.ttl || 180000);
      const retryReady = this.root.dataset.catalogueStatus !== 'fallback' || Date.now() - this.lastAttempt >= 60000;
      if (!this.loading && retryReady && ((!pending && key !== this.key) || stale)) this.load(false, key === this.key);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.destroyed || document.hidden || !this.near || !this.pageLoaded) return;
      const now = Date.now();
      const ttl = window.CsgCatalogueCache?.ttl || 180000;
      const refresh = this.root.dataset.catalogueStatus === 'fallback' ? this.lastAttempt + 60000 - now : this.lastFetch + ttl - now;
      this.timer = setTimeout(() => this.checkSlot(), Math.max(1000, Math.min(nextBoundary(now) - now + 100, refresh > 0 ? refresh : ttl)));
    }
    destroy() {
      this.destroyed = true; clearTimeout(this.timer); cancelAnimationFrame(this.frame);
      clearTimeout(this.pointerReleaseTimer);
      clearTimeout(this.touchReleaseTimer);
      this.requestVersion++; this.events.abort(); this.root.removeAttribute('aria-busy');
      this.resize.disconnect(); this.visibility?.disconnect(); this.proximity?.disconnect();
    }
  }
  function initAll() {
    instances.forEach((value, key) => { if (!value.root.isConnected) { value.destroy(); instances.delete(key); } });
    document.querySelectorAll('[data-csg27-carousel]').forEach(root => {
      if (instances.has(root.id)) { if (instances.get(root.id).root === root) return; instances.get(root.id).destroy(); }
      instances.set(root.id, new Carousel(root));
    });
  }
  window.CsgMy27 = { initAll, slotInfo, nextBoundary, selectSlot, sizeGroup, forSize, plainText };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', e => {
    instances.forEach((value,key) => { if (e.target.contains(value.root)) { value.destroy(); instances.delete(key); } });
  });
})();
